import { CraAttribute } from "@keita/lanepatrol-sdk";
import { useState, useEffect } from "react";

import { getAttributeValue } from "../../../../../coding/utils/attribute-value";
import { useStores } from "../../../../../shared/stores/RootStore";

export function useAttributeHighlight(attribute: CraAttribute) {
  const { codingStore, craNodeStore } = useStores();
  const node = craNodeStore.getSelected()!;

  const [isRecentlyChanged, setIsRecentlyChanged] = useState(false);
  const [previousValue, setPreviousValue] = useState<any>();

  useEffect(() => {
    const codingEntry = codingStore.getFromSelectedNode()!;
    if (codingEntry) {
      const attributeValue = getAttributeValue(
        attribute.name,
        codingEntry.attributes,
      );

      if (previousValue !== attributeValue) {
        setIsRecentlyChanged(true);
        setTimeout(() => {
          setIsRecentlyChanged(false);
        }, 3000);
        setPreviousValue(attributeValue);
      }
    }
    // eslint-disable-next-line
  }, [node]);

  return isRecentlyChanged;
}
